export default __webpack_public_path__ + "static/media/gallery02.64685a5f.jpg";